/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<g clipPath="url(#clip0_2004_11049)">
				<path
					opacity="0.4"
					d="M22 3L22 15"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M10.7497 22C10.91 22 11.0637 21.9363 11.177 21.823L16.1882 16.8118C17.2259 15.7741 17.7448 15.2552 18.1158 14.6497C18.4448 14.1129 18.6872 13.5276 18.8342 12.9154C19 12.2249 19 11.4911 19 10.0236V6.8C19 5.11984 19 4.27976 18.673 3.63803C18.3854 3.07354 17.9265 2.6146 17.362 2.32698C16.7202 2 15.8802 2 14.2 2H7.11801C5.65653 2 4.92579 2 4.33558 2.26743C3.8154 2.50314 3.3733 2.88242 3.06124 3.36072C2.70717 3.90339 2.59606 4.62564 2.37383 6.07012L1.85075 9.47012C1.55764 11.3753 1.41109 12.3279 1.6938 13.0691C1.94194 13.7197 2.40865 14.2637 3.01392 14.6079C3.70353 15 4.66733 15 6.59493 15H8.46141C8.6946 15 8.8112 15 8.89664 15.0098C9.82391 15.1165 10.4296 16.0351 10.1624 16.9294C10.1378 17.0118 10.0919 17.119 10 17.3333L9.08314 19.4727C8.57039 20.6691 9.448 22 10.7497 22V22Z"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2004_11049">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M10.7497 22C10.91 22 11.0637 21.9363 11.177 21.823L16.1882 16.8118C17.2259 15.7741 17.7448 15.2552 18.1158 14.6497C18.4448 14.1129 18.6872 13.5276 18.8342 12.9154C19 12.2249 19 11.4911 19 10.0236V6.8C19 5.11984 19 4.27976 18.673 3.63803C18.3854 3.07354 17.9265 2.6146 17.362 2.32698C16.7202 2 15.8802 2 14.2 2H7.11801C5.65653 2 4.92579 2 4.33558 2.26743C3.8154 2.50314 3.3733 2.88242 3.06124 3.36072C2.70717 3.90339 2.59606 4.62564 2.37383 6.07012L1.85075 9.47012C1.55764 11.3753 1.41109 12.3279 1.6938 13.0691C1.94194 13.7197 2.40865 14.2637 3.01392 14.6079C3.70353 15 4.66733 15 6.59493 15H8.46141C8.6946 15 8.8112 15 8.89664 15.0098C9.8239 15.1165 10.4296 16.0351 10.1624 16.9294C10.1378 17.0118 10.0919 17.119 10 17.3333L9.08314 19.4727C8.57039 20.6691 9.448 22 10.7497 22Z"
				fill="currentColor"
			/>
			<path
				d="M22 3L22 15M14.2 2H7.11801C5.65653 2 4.92579 2 4.33558 2.26743C3.8154 2.50314 3.3733 2.88242 3.06124 3.36072C2.70717 3.90339 2.59606 4.62564 2.37383 6.07012L1.85075 9.47012C1.55764 11.3753 1.41109 12.3279 1.6938 13.0691C1.94194 13.7197 2.40865 14.2637 3.01392 14.6079C3.70353 15 4.66733 15 6.59493 15H8.46141C8.6946 15 8.8112 15 8.89664 15.0098C9.82391 15.1165 10.4296 16.0351 10.1624 16.9294C10.1378 17.0118 10.0919 17.119 10 17.3333L9.08314 19.4727C8.57039 20.6691 9.448 22 10.7497 22V22C10.91 22 11.0637 21.9363 11.177 21.823L16.1882 16.8118C17.2259 15.7741 17.7448 15.2552 18.1158 14.6497C18.4448 14.1129 18.6872 13.5276 18.8342 12.9154C19 12.2249 19 11.4911 19 10.0236V6.8C19 5.11984 19 4.27976 18.673 3.63803C18.3854 3.07354 17.9265 2.6146 17.362 2.32698C16.7202 2 15.8802 2 14.2 2Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<g clipPath="url(#clip0_2004_11059)">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M4.13738 1.6064C4.92432 1.24982 5.89864 1.24982 7.84729 1.24982L13.35 1.24982C15.5903 1.24982 16.7104 1.24982 17.566 1.68579C18.3187 2.06929 18.9306 2.68121 19.3141 3.43386C19.75 4.28951 19.75 5.40961 19.75 7.64982L19.75 10.334C19.75 11.8016 19.75 12.5353 19.5843 13.2259C19.4373 13.8381 19.1949 14.4234 18.8659 14.9602C18.4948 15.5657 17.976 16.0845 16.9383 17.1222L16.9383 17.1223L11.4476 22.6129C11.36 22.7006 11.241 22.7498 11.117 22.7498C9.10305 22.7498 7.74518 20.6906 8.53853 18.8394L9.43407 16.7498C9.63695 16.2764 9.28971 15.7498 8.77467 15.7498L7.47289 15.7498C5.00767 15.7498 3.77506 15.7498 2.88402 15.2675C2.0171 14.7982 1.35401 14.0253 1.02199 13.0971C0.680728 12.143 0.868155 10.9248 1.24301 8.4882L1.52171 6.67665C1.81801 4.75067 1.96617 3.78768 2.43826 3.06411C2.85434 2.42638 3.4438 1.92067 4.13738 1.6064ZM21.25 15C21.25 15.4142 21.5858 15.75 22 15.75C22.4142 15.75 22.75 15.4142 22.75 15L22.75 3C22.75 2.58579 22.4142 2.25 22 2.25C21.5858 2.25 21.25 2.58579 21.25 3L21.25 15Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2004_11059">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M19 6L19 5.5V5.5C19 5.03558 19 4.80337 18.9743 4.60842C18.7971 3.26222 17.7377 2.2029 16.3915 2.02567C16.1966 2 15.9644 2 15.5 2H7.11798C5.6565 2 4.92576 2 4.33555 2.26743C3.81537 2.50314 3.37327 2.88242 3.06121 3.36072C2.70714 3.90339 2.59603 4.62564 2.3738 6.07012L1.85072 9.47012C1.55761 11.3753 1.41106 12.3279 1.69377 13.0691C1.94191 13.7197 2.40862 14.2637 3.01389 14.6079C3.7035 15 4.6673 15 6.5949 15H8.46138C8.69457 15 8.81117 15 8.89661 15.0098C9.82387 15.1165 10.4296 16.0351 10.1624 16.9294C10.1378 17.0118 10.0918 17.119 9.99997 17.3333L9.08311 19.4727C8.57036 20.6691 9.44797 22 10.7496 22V22C10.9099 22 11.0636 21.9363 11.177 21.823L16.5251 16.4749C17.2307 15.7693 17.5835 15.4165 17.8655 15.0256C18.4119 14.2685 18.774 13.3943 18.923 12.4726C19 11.9968 19 11.4978 19 10.5V10.5V10M22 14L22 6.2C22 5.0799 22 4.51984 21.782 4.09202C21.5902 3.71569 21.2843 3.40973 20.908 3.21799C20.4801 3 19.9201 3 18.8 3H18.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M22 3L22 15M14.2 2H7.11801C5.65653 2 4.92579 2 4.33558 2.26743C3.8154 2.50314 3.3733 2.88242 3.06124 3.36072C2.70717 3.90339 2.59606 4.62564 2.37383 6.07012L1.85075 9.47012C1.55764 11.3753 1.41109 12.3279 1.6938 13.0691C1.94194 13.7197 2.40865 14.2637 3.01392 14.6079C3.70353 15 4.66733 15 6.59493 15H8.46141C8.6946 15 8.8112 15 8.89664 15.0098C9.82391 15.1165 10.4296 16.0351 10.1624 16.9294C10.1378 17.0118 10.0919 17.119 10 17.3333L9.08314 19.4727C8.57039 20.6691 9.448 22 10.7497 22V22C10.91 22 11.0637 21.9363 11.177 21.823L16.1882 16.8118C17.2259 15.7741 17.7448 15.2552 18.1158 14.6497C18.4448 14.1129 18.6872 13.5276 18.8342 12.9154C19 12.2249 19 11.4911 19 10.0236V6.8C19 5.11984 19 4.27976 18.673 3.63803C18.3854 3.07354 17.9265 2.6146 17.362 2.32698C16.7202 2 15.8802 2 14.2 2Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M7.84731 1.25C5.89866 1.25 4.92434 1.25 4.1374 1.60658C3.44382 1.92085 2.85436 2.42656 2.43828 3.06429C1.96618 3.78786 1.81803 4.75085 1.52173 6.67684L1.24303 8.48838C0.868172 10.9249 0.680745 12.1432 1.02201 13.0972C1.35403 14.0254 2.01712 14.7983 2.88404 15.2676C3.77508 15.75 5.00769 15.75 7.47291 15.75H8.77469C9.28972 15.75 9.63697 16.2766 9.43409 16.75L8.53855 18.8396C7.7452 20.6907 9.10306 22.75 11.1171 22.75C11.2411 22.75 11.36 22.7007 11.4477 22.6131L16.9383 17.1224C17.976 16.0847 18.4949 15.5659 18.8659 14.9604C19.1949 14.4235 19.4373 13.8383 19.5843 13.2261C19.7501 12.5355 19.7501 11.8018 19.7501 10.3342V7.65C19.7501 5.40979 19.7501 4.28969 19.3141 3.43404C18.9306 2.68139 18.3187 2.06947 17.566 1.68597C16.7104 1.25 15.5903 1.25 13.3501 1.25L7.84731 1.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M22 15.7502C21.5858 15.7502 21.25 15.4144 21.25 15.0002L21.25 3.00018C21.25 2.58597 21.5858 2.25018 22 2.25018C22.4142 2.25018 22.75 2.58597 22.75 3.00018L22.75 15.0002C22.75 15.4144 22.4142 15.7502 22 15.7502Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
